import { RichtextValue, Localized, resolveLocalizedValue } from "@robe/core";
import { useData } from "../../hooks";
import { useMemo } from "react";

type RichtextInput = RichtextValue | Localized<RichtextValue> | undefined;

export const useSlateValue = (richtext: RichtextInput): RichtextValue | undefined => {
  const { core } = useData();

  return useMemo(() => {
    return richtext === undefined
      ? richtext
      : richtext && "links" in richtext
        ? (richtext as RichtextValue)
        : (resolveLocalizedValue(core.currentLocale, core.locales)(richtext as Record<string, RichtextValue>)?.value ?? undefined);
  }, [richtext, core.currentLocale, core.locales]);
};
